import React, { useState, useEffect } from 'react';
import Card from '../../common/Card/Card';
import Button from '../../common/Button/Button';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ScopeViewer from '../../common/ScopeViewer/ScopeViewer';
import { getAllProjects, approveProjectScope } from '../../../services/projectService';
import { useToast } from '../../../context/ToastContext';
import styles from './ProjectScopeApproval.module.css';

const ProjectScopeApproval = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const data = await getAllProjects();
      setProjects(data || []);
    } catch (error) {
      console.error('Error fetching projects:', error);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (projectId, approved) => {
    try {
      await approveProjectScope(projectId, approved);
      approved ? toast.success('Project scope approved successfully!') : toast.success('Project scope rejected.');
      fetchProjects(); // Refresh list
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.detail || error.message));
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  const pendingScopes = (projects || []).filter(p => p.project_scope && !p.scope_approved);

  return (
    <Card title="Project Scope Approvals">
      {pendingScopes.length === 0 ? (
        <p className={styles.empty}>No pending project scopes</p>
      ) : (
        <div className={styles.scopesList}>
          {pendingScopes.map(project => (
            <div key={project.id} className={styles.scopeItem}>
              <h4>{project.project_name}</h4>
              <ScopeViewer
                scopeData={project.project_scope}
                projectId={project.id}
                fileName={project.scope_file_name}
              />
              <div className={styles.actions}>
                <Button size="small" onClick={() => handleApprove(project.id, true)} loading={loading}>
                  Approve
                </Button>
                <Button size="small" variant="danger" onClick={() => handleApprove(project.id, false)} loading={loading}>
                  Reject
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ProjectScopeApproval;